import { Col, Row } from 'antd'
import React from 'react'
import { translate } from 'react-i18next'
import { IconHelper } from '../../helpers/index'

const Header = ({ t }) => {
    const { IconArrowBack } = IconHelper

    const handleBack = () => {
        window.location.href = `${window._env_.vRoomUrl}/portal`
    }

    return (
        <Row className="participant-header">
            <Col span={24} className="participant-leave">
                <IconArrowBack
                    style={{ cursor: 'pointer' }}
                    onClick={handleBack}
                />
                <span className="participant-leave-text">{t('lobby_participant.leave')}</span>
            </Col>
        </Row>
    )
}

export default translate()(Header)

